const businessEntityFilters = {
  id: null
}

export default () => Object.assign({}, businessEntityFilters)
